import {IViewItemConfig} from "./IViewpoint";
import {IOptionItemChoice} from "@bimaire/optionslib";

export function getViewOptions(selectedViewItem: IViewItemConfig, showFurniture: boolean) {
    const viewOptions: Record<string, string> = {};

    viewOptions["VSC-VIEW"] = (selectedViewItem && (selectedViewItem.type === "camera" || selectedViewItem.type === "viewpoint" || selectedViewItem.type === "view")) ? (selectedViewItem?.levelgroup ?? "vsc-view-all") : "vsc-view-all";
    viewOptions["VSC-FURN"] = showFurniture ? "vsc-furn-std" : "vsc-furn-none";
    return viewOptions;
}
export function getChoices(options:Record<string, string>): IOptionItemChoice[] {
    const activeChoices: IOptionItemChoice[] = [];
    for (const viewOption of Object.keys(options)) {
        activeChoices.push({
            quantity: 1,
            price: 0,

            choice: {
                items: [
                    {
                        item: {
                            name: viewOption,
                            type: "Attribute",
                            id: viewOption,
                            menu: null,
                            categories: {},
                            index: 0,
                        },
                        level: "Selection"
                    },
                    {
                        item: {
                            name: options[viewOption],
                            type: "Attribute",
                            id: options[viewOption],
                            menu: null,
                            categories: {},
                            index: 0
                        },
                        level: "Value"
                    }
                ]
            }
        });
    }
    return activeChoices;
}